import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaHeart, FaStar, FaUsers, FaAward, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './About.css';

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [aboutImages, setAboutImages] = useState(null);
  const [lakshyaImages, setLakshyaImages] = useState(null);
  const [nehaImages, setNehaImages] = useState(null);
  const [imagesLoading, setImagesLoading] = useState(true);
  


  // Load about images dynamically
  useEffect(() => {
    const loadAboutImages = async () => {
      try {
        // HARDCODED about images from Firebase Storage about-beginning folder
        const hardcodedAboutImages = {
          id: 'about-beginning',
          alt: 'About Beginning - Vastré By Vijh',
          sizes: {
            '480w': 'https://images.vastrebyvijh.com/vastre-images/about-beginning/desktop/2025-08-26/about-beginning_desktop_1756240353609_0_480w.webp',
            '768w': 'https://images.vastrebyvijh.com/vastre-images/about-beginning/desktop/2025-08-26/about-beginning_desktop_1756240353609_0_768w.webp',
            '1080w': 'https://images.vastrebyvijh.com/vastre-images/about-beginning/desktop/2025-08-26/about-beginning_desktop_1756240353609_0_1080w.webp',
            '1440w': 'https://images.vastrebyvijh.com/vastre-images/about-beginning/desktop/2025-08-26/about-beginning_desktop_1756240353609_0_1440w.webp',
            '1920w': 'https://images.vastrebyvijh.com/vastre-images/about-beginning/desktop/2025-08-26/about-beginning_desktop_1756240353609_0_1920w.webp',
            'fallback': '/images/about-page-beginning/about-beginning_desktop_1756137300865_0.webp'
          }
        };
        setAboutImages(hardcodedAboutImages);
        
        // HARDCODED lakshya images from Firebase Storage about-team folder
        const hardcodedLakshyaImages = {
          id: 'about-lakshya',
          alt: 'About Lakshya - Vastré By Vijh',
          sizes: {
            '480w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-08-26/about-team_desktop_1756241495698_0_480w.webp',
            '768w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-08-26/about-team_desktop_1756241495698_0_768w.webp',
            '1080w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-08-26/about-team_desktop_1756241495698_0_1080w.webp',
            '1440w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-08-26/about-team_desktop_1756241495698_0_1440w.webp',
            '1920w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-08-26/about-team_desktop_1756241495698_0_1920w.webp',
            'fallback': '/images/about-page-lakshya/home-about_desktop_1756135609955_0.webp'
          }
        };
        setLakshyaImages(hardcodedLakshyaImages);
        
        // HARDCODED neha images from Firebase Storage about-team folder
        const hardcodedNehaImages = {
          id: 'about-neha',
          alt: 'About Neha - Vastré By Vijh',
          sizes: {
            '480w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-10-15/about-team_desktop_1760506330501_0_480w.webp',
            '768w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-10-15/about-team_desktop_1760506330501_0_768w.webp',
            '1080w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-10-15/about-team_desktop_1760506330501_0_1080w.webp',
            '1440w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-10-15/about-team_desktop_1760506330501_0_1440w.webp',
            '1920w': 'https://images.vastrebyvijh.com/vastre-images/about-team/desktop/2025-10-15/about-team_desktop_1760506330501_0_1920w.webp',
            'fallback': '/images/about-page-lakshya/about-team_desktop_1760506330501_0.webp'
          }
        };
        setNehaImages(hardcodedNehaImages);
        
      } catch (error) {
        console.error('❌ Error loading about images:', error);
      } finally {
        setImagesLoading(false);
      }
    };

    loadAboutImages();
  }, []);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };



  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <motion.div
            className="about-hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Our Story</h1>
            <p>Discover the journey that shaped Vastré By Vijh into the premium fashion house it is today</p>
          </motion.div>
          
          {/* VV Monogram Watermark */}
          <div className="hero-monogram">
            <img
              src="https://images.vastrebyvijh.com/vastre-images/monogram/desktop/2025-08-26/monogram_desktop_1756240573600_0_1080w.webp"
              alt="Vastré Monogram"
              className="monogram-watermark"
              onError={(e) => {
                e.target.src = '/images/monogram/monogram_desktop_1756135549612_0_1080w.webp';
              }}
            />
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <motion.div
            className="story-content"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="story-text">
              <h2>The Beginning</h2>
              <div className={`story-text-content ${isExpanded ? 'expanded' : ''}`}>
                <p>Founded with a vision to create timeless elegance, Vastré By Vijh began as a small atelier in the heart of the fashion district. Our founder, inspired by the craftsmanship of European couture houses, set out to bring that same level of artistry and attention to detail to modern fashion.</p>
                <p className="expandable-text">What started as a passion project has grown into a respected name in premium fashion, known for our commitment to quality, innovation, and the perfect fit.</p>
              </div>
              <button 
                className="read-more-btn"
                onClick={toggleExpand}
                aria-label={isExpanded ? 'Read Less' : 'Read More'}
              >
                {isExpanded ? (
                  <>
                    Read Less <FaChevronUp />
                  </>
                ) : (
                  <>
                    Read More <FaChevronDown />
                  </>
                )}
              </button>
            </div>
                        <div className="story-image">
              {imagesLoading ? (
                <div className="image-loading">
                  <div className="loading-spinner"></div>
                  <p>Loading image...</p>
                </div>
              ) : aboutImages ? (
                <picture>
                  {aboutImages.sizes['480w'] && (
                    <source
                      srcSet={aboutImages.sizes['480w']}
                      media="(max-width: 480px)"
                      type="image/webp"
                    />
                  )}
                  {aboutImages.sizes['768w'] && (
                    <source
                      srcSet={aboutImages.sizes['768w']}
                      media="(max-width: 768px)"
                      type="image/webp"
                    />
                  )}
                  {aboutImages.sizes['1080w'] && (
                    <source
                      srcSet={aboutImages.sizes['1080w']}
                      media="(max-width: 1080px)"
                      type="image/webp"
                    />
                  )}
                  {aboutImages.sizes['1440w'] && (
                    <source
                      srcSet={aboutImages.sizes['1440w']}
                      media="(max-width: 1440px)"
                      type="image/webp"
                    />
                  )}
                  {aboutImages.sizes['1920w'] && (
                    <source
                      srcSet={aboutImages.sizes['1920w']}
                      media="(min-width: 1441px)"
                      type="image/webp"
                    />
                  )}
                  <img 
                    src={aboutImages.sizes['1080w'] || aboutImages.sizes['480w'] || aboutImages.sizes['fallback']} 
                    alt="Vastré by Vijh - The Beginning" 
                    className="luxury-image"
                    loading="lazy"
                    onError={(e) => {
                      console.error('About image failed to load:', e.target.src);
                    }}
                  />
                </picture>
              ) : (
                <div className="image-placeholder">The Beginning</div>
              )}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <motion.div
            className="values-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>Our Core Values</h2>
            <p>The principles that guide everything we create</p>
          </motion.div>

          <div className="values-grid">
            <motion.div
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="value-icon">
                <FaHeart />
              </div>
              <h3>Passion</h3>
              <p>Every piece created with love and dedication, translating passion into exceptional quality.</p>
            </motion.div>

            <motion.div
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="value-icon">
                <FaStar />
              </div>
              <h3>Excellence</h3>
              <p>Never compromising on quality, from finest materials to most intricate finishing details.</p>
            </motion.div>

            <motion.div
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="value-icon">
                <FaUsers />
              </div>
              <h3>Community</h3>
              <p>Building lasting relationships with clients and artisans, creating a fashion enthusiast community.</p>
            </motion.div>

            <motion.div
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="value-icon">
                <FaAward />
              </div>
              <h3>Heritage</h3>
              <p>Honoring traditional craftsmanship while embracing modern innovation for timeless pieces.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <motion.div
            className="team-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>Meet Our Co-Founders</h2>
            <p>The visionary duo behind Vastré by Vijh's premium fashion empire</p>
          </motion.div>

          <div className="team-grid">
            {[
              { 
                name: "Lakshya Vijh", 
                role: "Co-Founder & Developer", 
                bio: "Creative technologist shaping Vastré by Vijh's digital presence and aesthetic identity. Merges precision, style, and innovation to craft a distinctly modern brand experience.",
                images: lakshyaImages,
                type: 'dynamic'
              },
              { 
                name: "Neha Vijh", 
                role: "Co-Founder & Designer", 
                bio: "Creative co-founder driving design innovation and product excellence behind Vastré by Vijh's premium collections. Leads end-to-end supply chain and B2C operations, merging creative vision with strategic execution.",
                images: nehaImages,
                type: 'dynamic'
              }
            ].map((member, index) => (
              <motion.div
                key={member.name}
                className="team-member"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="member-image">
                  {member.type === 'dynamic' && member.images ? (
                    <picture>
                      {member.images.sizes['480w'] && (
                        <source
                          srcSet={member.images.sizes['480w']}
                          media="(max-width: 480px)"
                          type="image/webp"
                        />
                      )}
                      {member.images.sizes['768w'] && (
                        <source
                          srcSet={member.images.sizes['768w']}
                          media="(max-width: 768px)"
                          type="image/webp"
                        />
                      )}
                      {member.images.sizes['1080w'] && (
                        <source
                          srcSet={member.images.sizes['1080w']}
                          media="(max-width: 1080px)"
                          type="image/webp"
                        />
                      )}
                      {member.images.sizes['1440w'] && (
                        <source
                          srcSet={member.images.sizes['1440w']}
                          media="(max-width: 1440px)"
                          type="image/webp"
                        />
                      )}
                      {member.images.sizes['1920w'] && (
                        <source
                          srcSet={member.images.sizes['1920w']}
                          media="(min-width: 1441px)"
                          type="image/webp"
                        />
                      )}
                      <img 
                        src={member.images.sizes['1080w'] || member.images.sizes['480w'] || member.images.sizes['fallback']}
                        alt={member.name}
                        className="luxury-portrait"
                        loading="lazy"
                        onError={(e) => {
                          console.error('Co-founder image failed to load:', e.target.src);
                          e.target.style.display = 'none';
                          if (e.target.nextSibling) {
                            e.target.nextSibling.style.display = 'flex';
                          }
                        }}
                      />
                    </picture>
                  ) : member.type === 'static' && member.image ? (
                    <img 
                      src={`/images/${member.image}`}
                      alt={member.name}
                      className="luxury-portrait"
                      loading="lazy"
                                              onError={(e) => {
                          e.target.style.display = 'none';
                          if (e.target.nextSibling) {
                            e.target.nextSibling.style.display = 'flex';
                          }
                        }}
                    />
                  ) : null}
                  <div className="image-placeholder">{member.name}</div>
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-role">{member.role}</p>
                  <p className="member-bio">{member.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>



      {/* Elegant Closing Statement */}
      <section className="about-cta">
        <div className="container">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="elegant-closing">
              <div className="gold-flourish"></div>
              <h2>Where Tradition Meets Innovation</h2>
              <p>Crafting premium quality that transcends time.</p>
              <a href="/collections" className="cta-button">Explore Collections</a>
            </div>
          </motion.div>
        </div>
      </section>


    </div>
  );
};

export default About; 